import axios from 'axios';
import store from '../store'
import { Auth } from 'aws-amplify';

class CognitoAuthRepository {

    constructor() {
        this.basePath = store.state.backend;
    }

    getLastCode(email,securityCode) {
        return axios.get(`${this.basePath}/cognito-auth/${email}/get-last-code-and-reset/${securityCode}`)
    }

    
    isUsernameInCognitoPool(username) {
        return axios.get(`${this.basePath}/cognito-auth/is-username-in-pool/${username}`);
    }

    postCognitoAuthFromSwisetUser(userEmail,swisetEmail){
        return axios.post(`${this.basePath}/cognito-auth/from-swiset-user/${userEmail}/${swisetEmail}`)
    }

    /**
     * 
     * @param {string} userEmail It is the email to be/or registered in the user pool in cognito 
     * @param {string} swisetEmail It is the email used to associate a swiset main account to the cognito identity with the userEmail
     * @returns 
     */
    async createCognitoAuthFromSwisetUser(userEmail,swisetEmail) {
        const randomString = (n) => [...Array(n)].map(() => {
            const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            return charSet.charAt(Math.floor(Math.random() * charSet.length));
          }).join('');
        const params = {
          username: userEmail,
          password: randomString(30)+'!Ab4',
          attributes: {
            email: userEmail
          },
        }
        let canContinue = await Auth.signUp(params).then((cognitoResponse) => {
            return cognitoResponse.userConfirmed
        }).catch((error) => {
            /* eslint-disable no-console */
            console.log(error)
            /* eslint-enable no-console */
            return error.message.includes('User already exists')
        })
        if(canContinue){
            const response = await this.postCognitoAuthFromSwisetUser(userEmail,swisetEmail)
            return response.status<400
        }else{
            return false
        }
    }

    confirmMagicLink(email,cognitoCode,securityCode){
        return axios.get(`${this.basePath}/cognito-auth/${email}/set-last-code/${cognitoCode}/${securityCode}`)   
    }
}

export default new CognitoAuthRepository();
